<template>
    <section class="c-account__section">
        <h2 class="c-account__title">{{ _t("Bonjour") }} {{ currentUser.firstname }} {{ currentUser.lastname }}</h2>
    </section>

    <section id="historique" class="c-account__section">
        <h2 class="c-account__title">
            {{ _t("Historique d'achat") }}
        </h2>
        <!--Card history-->
        <div class="c-account-historique">
            <div v-if="isEmpty(invoices)" class="o-text c-account__box">
                <p>{{ _t("Aucune commande.") }}</p>
            </div>
            <div v-for="invoice in invoices" :key="invoice.invoice_number" class="c-cart__item">
                <div class="c-cart__item-header">
                    <div class="c-cart__product-name">
                        <h3 class="c-cart__product__name">{{ _t("Commande #") }}{{ invoice.invoice_number }}</h3>
                        <p class="c-cart__product__information"></p>
                        <p class="c-cart__product__price">{{ formatMoney(invoice.cart_data.total) }}</p>
                        <p class="c-cart__product__date">{{ invoice.order_date}}</p>
                    </div>
                    <div class="c-cart__product-btn__wrapper">
                        <a class="c-cart__product-btn-delete" target="_blank" :href="pages.invoice+'?token='+invoice.cart_token">
                            <svg aria-hidden="true" focusable="false" class="o-ico -icon-cart">
                                <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=5dea11d359b55f8dfd#download"></use>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!--Button load more-->
        <div v-if="loadMore" class="">
            <div class="c-account__load-more">
                <div class="o-button__container">
                    <button :disabled="isLoading" @click="getInvoices()" class="o-button o-button-cart" type="submit">
                        <span class="o-button__text">{{ _t("Charger plus") }}</span>
                        <span class="sr-only">{{ _t("Charger plus") }}</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
export default {
    name: 'DashboardHome',
    data: function () {
        return {
            invoices: [],
            page: 1,
            loadMore: false,
            isLoading: true,
            pages: window.ajax_var.pages,
        }
    },
    props: {
        currentUser: {
            type: Object,
            required: true
        }
    },
    methods: {
        getInvoices(){
            let params = {
                _wpnonce: window.ajax_var.nonce,
                page: this.page,
            }

            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.get('/wp-json/stereostore/v1/invoices', { params })
                .then(response => {
                    this.invoices = this.invoices.concat(response.data.invoices)
                    this.loadMore = response.data.load_more
                    this.page++
                    this.isLoading = false
                })
                .catch(error => {
                    console.log(error)
                    this.isLoading = false
                })
        },
        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        },
        formatMoney(value) {
            let language = window.ajax_var.currentLang;
            let currency = window.ajax_var.currency;
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
    },
    mounted() {
        this.getInvoices();
    }
}
</script>